import { CATEGORIAS_DE_SERVICO, SPECIALTY_LABELS, type SpecialtyCode } from "@bookdental/schemas";

// Desenhos próprios em apps/app/public/icones — usados como máscara, a cor vem da regra do nome.
const ESPECIALIDADE: Record<SpecialtyCode, string> = {
  CLINICO_GERAL: "clinico-geral",
  ORTODONTIA: "ortodontia",
  ENDODONTIA: "endodontia",
  IMPLANTODONTIA: "implantodontia",
  PERIODONTIA: "periodontia",
  ODONTOPEDIATRIA: "odontopediatria",
  CIRURGIA_BUCOMAXILO: "cirurgia-bucomaxilo",
  PROTESE_DENTARIA: "protese-dentaria",
  DENTISTICA: "dentistica",
  HARMONIZACAO_OROFACIAL: "harmonizacao-orofacial",
  DTM_DOR_OROFACIAL: "disfuncao-temporomandibular",
  ESTOMATOLOGIA: "estomatologia",
  RADIOLOGIA: "radiologia",
  ODONTOGERIATRIA: "odontogeriatria",
  PACIENTES_ESPECIAIS: "pacientes-especiais",
  ORTOPEDIA_FUNCIONAL: "ortopedia-maxilar",
  PATOLOGIA_ORAL: "patologia-oral",
  PROTESE_BUCOMAXILOFACIAL: "protese-bucomaxilo",
  ODONTOLOGIA_DO_ESPORTE: "odontologia-esporte",
  ODONTOLOGIA_DO_TRABALHO: "odontologia-trabalho",
  ODONTOLOGIA_HOSPITALAR: "odontologia-hospitalar",
  ODONTOLOGIA_LEGAL: "odontologia-legal",
  SAUDE_COLETIVA: "saude-coletiva",
  ACUPUNTURA: "acupuntura",
  HOMEOPATIA: "homeopatia",
  CIRURGIA_ESTETICA_OROFACIAL: "cirurgia-estetica-orofacial",
};

// Categoria sem desenho próprio fica de fora e segue com o ícone do lucide.
const CATEGORIA: Partial<Record<(typeof CATEGORIAS_DE_SERVICO)[number], string>> = {
  "Próteses fixas sobre dentes": "servicos/protese-sobre-dente",
  "Restaurações indiretas e odontologia estética": "especialidades/dentistica",
  "Próteses sobre implantes": "servicos/protese-sobre-implante",
  "Próteses totais removíveis": "servicos/proteses-totais-parciais",
  "Próteses parciais removíveis (PPR)": "servicos/proteses-totais-parciais",
  "Placas oclusais e dispositivos terapêuticos": "servicos/placas",
  "Ortodontia e contenções": "servicos/aparelhos-ortodonticos",
  "Modelos odontológicos": "servicos/modelos",
  "Guias cirúrgicos e planejamento": "servicos/planejamentos-digitais",
  "Provisórios e temporários": "servicos/protese-provisoria",
  "Odontologia digital – CAD/CAM": "servicos/planejamentos-digitais",
  "Próteses bucomaxilofaciais e trabalhos especiais": "especialidades/protese-bucomaxilo",
};

const PELO_NOME = new Map<string, string>([
  ...(Object.entries(ESPECIALIDADE) as [SpecialtyCode, string][]).map(
    ([code, arq]): [string, string] => [SPECIALTY_LABELS[code], `especialidades/${arq}`],
  ),
  ...Object.entries(CATEGORIA),
]);

export function imagemDoIcone(nome: string): string | undefined {
  const arq = PELO_NOME.get(nome);
  return arq ? `/icones/${arq}.png` : undefined;
}
